import { InjectionToken } from '@angular/core';
import { ILanguageService } from '../interfaces/language.interface';

export const MAXBRAIN_LANGUAGE_SERVICE = new InjectionToken<ILanguageService>('MAXBRAIN_LANGUAGE_SERVICE');
